import { SVGProps } from 'react';

export const IconLockUser = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox='0 0 24 24' fill='none' {...props}>
      <path
        d='M12.5746 13.2666C10.3801 13.2666 6 14.622 6 17.3125V19.3355H19.1493V17.3125C19.1493 14.622 14.7691 13.2666 12.5746 13.2666Z'
        fill='currentColor'
      />
      <path
        d='M12.575 11.9175C14.6233 11.9175 16.2837 10.2571 16.2837 8.20876C16.2837 6.16047 14.6233 4.5 12.575 4.5C10.5267 4.5 8.86621 6.16047 8.86621 8.20876C8.86621 10.2571 10.5267 11.9175 12.575 11.9175Z'
        fill='currentColor'
      />
      <path
        d='M4.80078 7.21777C5.96903 7.21777 6.91602 8.16476 6.91602 9.33301V10.0381H7.62109V13.5635H1.98047V10.0381H2.68555V9.33301C2.68555 8.16476 3.63254 7.21777 4.80078 7.21777ZM4.79785 8.62793C4.40844 8.62793 4.09277 8.94359 4.09277 9.33301V10.0381H5.50293V9.33301C5.50293 8.94368 5.18714 8.62808 4.79785 8.62793Z'
        fill='currentColor'
      />
    </svg>
  );
};
